'use client';

import { suggestedQuestionChipColors } from '@/lib/agents/suggested-question-chips';

interface FloatingSuggestedBubblesProps {
  questions: string[];
  visible: boolean;
  theme?: 'light' | 'dark';
  accentColor?: string;
  onSelect: (question: string) => void;
}

export function FloatingSuggestedBubbles({
  questions,
  visible,
  theme = 'light',
  accentColor,
  onSelect,
}: FloatingSuggestedBubblesProps) {
  if (questions.length === 0) return null;

  const colors = suggestedQuestionChipColors(theme === 'dark' ? 'dark' : 'light');

  return (
    <>
      <style>{`
        @keyframes linkai-suggest-in {
          0% { opacity: 0; transform: translateY(8px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div
        aria-hidden={!visible}
        className="flex w-full flex-col items-start justify-end gap-1.5 overflow-visible"
        style={{
          maxHeight: visible ? '14rem' : 0,
          marginBottom: visible ? '0.55rem' : 0,
          opacity: visible ? 1 : 0,
          pointerEvents: visible ? 'auto' : 'none',
          transform: visible ? 'translateY(0)' : 'translateY(8px)',
          transition:
            'opacity 0.22s ease, transform 0.28s cubic-bezier(0.32, 0.72, 0, 1), max-height 0.28s ease, margin-bottom 0.22s ease',
        }}
      >
        {questions.map((question, index) => (
          <button
            key={`${index}-${question}`}
            type="button"
            onMouseDown={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onSelect(question);
            }}
            className="max-w-full rounded-full px-3.5 py-1.5 text-left text-xs font-normal sm:text-[13px]"
            style={{
              backgroundColor: colors.bg,
              border: 'none',
              color: colors.text,
              animation: visible
                ? `linkai-suggest-in 0.28s cubic-bezier(0.32, 0.72, 0, 1) ${index * 0.05}s both`
                : 'none',
            }}
            onMouseEnter={(event) => {
              event.currentTarget.style.backgroundColor = colors.hover;
              if (accentColor) {
                event.currentTarget.style.backgroundColor = colors.hover;
              }
            }}
            onMouseLeave={(event) => {
              event.currentTarget.style.backgroundColor = colors.bg;
            }}
          >
            {question}
          </button>
        ))}
      </div>
    </>
  );
}
